<div id="submenu">
    <span class="selector"
          (click)="select('domain')"
          [ngClass]="{link: currentSection() != 'domain', selected: currentSection() == 'domain'}">Domain Info</span>

    <span class="selector"
          (click)="select('search')"
          [ngClass]="{link: currentSection() != 'search', selected: currentSection() == 'search'}">Search Domains</span>

    <span class="selector"
          (click)="select('status')"
          [ngClass]="{link: currentSection() != 'status', selected: currentSection() == 'status'}">Status Summary</span>

    <span class="selector"
          (click)="select('check')"
          [ngClass]="{link: currentSection() != 'check', selected: currentSection() == 'check'}">Check Availability</span>
</div>
@if (currentSection() == 'domain') {
    <app-domain></app-domain>
} @else if (currentSection() == 'search') {
    <app-domain-search></app-domain-search>
} @else if (currentSection() == 'check') {
    <app-domain-check></app-domain-check>
} @else {
    <app-domains-summary></app-domains-summary>
}